import "./style.css"

export const InputDescription = ()=>{
    return(<input type="text" className="font-size-4 font-color-7 input-description" placeholder="Digite aqui sua descrição" required/>)
}

export const InputValueNumber = ()=>{
    return(<input type="number" className="font-size-4 font-color-7 input-value-number" placeholder="1" required/>)
}